
class AppmaxFrequency extends HTMLElement {
    connectedCallback() {
        this.trigger = this.querySelector('.appmax-freq__trigger');
        this.panel = this.querySelector('.appmax-freq__panel');
        this.triggerText = this.querySelector('.appmax-freq__trigger-text');
        this.inputs = Array.from(this.querySelectorAll('.appmax-freq__input'));
        if (!this.trigger || !this.panel) return;

        this.form =
            document.getElementById(this.dataset.form) || this.closest('form');

        this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        document.addEventListener('click', this.onDocumentClick.bind(this));
        document.addEventListener('keydown', this.onKeydown.bind(this));

        if (this.form) {
            this.form.addEventListener('submit', this.onSubmit.bind(this), true);
        }
    }

    get isOpen() {
        return this.classList.contains('is-open');
    }

    open() {
        this.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
        this.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
    }

    onTriggerClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.isOpen ? this.close() : this.open();
    }

    onDocumentClick(event) {
        if (!this.contains(event.target)) this.close();
    }

    onKeydown(event) {
        if (event.key === 'Escape' && this.isOpen) {
            this.close();
            this.trigger.focus();
        }
    }

    onChange(event) {
        const input = event.target;
        if (!input.classList.contains('appmax-freq__input')) return;

        this.classList.remove('has-error');
        this.triggerText.innerHTML =
            `<span class="appmax-freq__trigger-name">${input.dataset.label}</span>` +
            `<span class="appmax-freq__trigger-price">${input.dataset.price}</span>`;
        this.close();
    }

    onSubmit(event) {
        const chosen = this.inputs.some((input) => input.checked);
        if (chosen) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.classList.add('has-error');
        this.open();
        this.trigger.focus();
    }
}

customElements.get('appmax-frequency') ||
    customElements.define('appmax-frequency', AppmaxFrequency);
